$( document ).ready(function() {
  $('.faqs_section ul.accordion li:first-child .accordion_heading').addClass('active');
  $('.faqs_section ul.accordion li:first-child .accordion_content').addClass('active').slideDown(350);
  $('.faqs_section ul.accordion li .accordion_heading').click(function(e) {
      e.preventDefault();
      let $this = $(this);
      if ($this.next().hasClass('active')) {
          $this.next().removeClass('active');
          $this.removeClass('active');
          $this.next().slideUp(350);
      } else {
          $this.parent().parent().find('.accordion_content').removeClass('active');
          $('.faqs_section ul.accordion li .accordion_heading').removeClass('active');
          $this.toggleClass('active');
          $this.parent().parent().find('.accordion_content').slideUp(350);
          $this.next().toggleClass('active');
          $this.next().slideToggle(350);
      }
  });

  // sub accordion
  $('.faqs_section ul.accordion .accordion_content .sub_accordion_item .sub_accordion_heading').click(function(e) {
      e.preventDefault();
      let $this = $(this);
      if ($this.next().hasClass('active')) {
          $this.next().removeClass('active');
          $this.removeClass('active');
          $this.next().slideUp(350);
      } else {
          $this.parent().parent().find('.sub_accordion_content').removeClass('active');
          $('.faqs_section ul.accordion .accordion_content .sub_accordion_item .sub_accordion_heading').removeClass('active');
          $this.toggleClass('active');
          $this.parent().parent().find('.sub_accordion_content').slideUp(350);
          $this.next().toggleClass('active');
          $this.next().slideToggle(350);
      }
  });

  
  if($(window).width() <= 991) {
    $('.icon_with_content_second .item:first-child .box .head').addClass('active');
    $('.icon_with_content_second .item:first-child .box .des').addClass('active').slideDown(350);
    $('.icon_with_content_second .item .box .head').click(function(e) {
        e.preventDefault();
        let $this = $(this);
        let $description = $this.next('.des');
    
        if (!$description.hasClass('active')) {
            $('.icon_with_content_second .item .box .head').removeClass('active');
            $('.icon_with_content_second .item .box .des').removeClass('active').slideUp(350);
    
            $this.addClass('active');
            $description.addClass('active').slideDown(350);
        } else {
            $this.removeClass('active');
            $description.removeClass('active').slideUp(350);
        }
    });
    $('.icon_with_title .row').slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
    });
    $('.video_slider').slick({
      centerMode: true,
      slidesToShow: 2,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 576,
          settings: {
            centerMode: true,
            slidesToShow: 1,
          }
        }
      ]
    });
    $('.product_customer_section .customer_list').slick({
      slidesToShow: 1,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
    });
  }
  /* horizontal slider */
  $('.custom_product_slider_for_horizontal').slick({
   	slidesToShow: 1,
   	slidesToScroll: 1,
   	arrows: true,
   	fade: false,
    asNavFor: '.custom_product_slider_nav_horizontal',
    adaptiveHeight: true,
    infinite: false,
    dots: true,
    prevArrow:`<div class='slick-arrow prev'><svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.500002" width="44" height="44" rx="22" fill="white"/>
    <rect x="0.5" y="0.500002" width="44" height="44" rx="22" stroke="#E0E0E0"/>
    <g clip-path="url(#clip0_2085_74)">
    <path d="M25.766 33.0164L27.75 31.0074L19.243 22.5004L27.75 13.9934L25.766 11.9844L15.25 22.5004L25.766 33.0164Z" fill="#464646"/>
    </g>
    <defs>
    <clipPath id="clip0_2085_74">
    <rect width="12.5" height="21.0312" fill="white" transform="translate(15.25 11.9844)"/>
    </clipPath>
    </defs>
    </svg>
    </div>`,
        nextArrow:`<div class='slick-arrow next'><svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.500002" width="44" height="44" rx="22" fill="white"/>
    <rect x="0.5" y="0.500002" width="44" height="44" rx="22" stroke="#E0E0E0"/>
    <g clip-path="url(#clip0_2085_78)">
    <path d="M19.234 33.0164L17.25 31.0074L25.757 22.5004L17.25 13.9934L19.234 11.9844L29.75 22.5004L19.234 33.0164Z" fill="#464646"/>
    </g>
    <defs>
    <clipPath id="clip0_2085_78">
    <rect width="12.5" height="21.0312" fill="white" transform="translate(17.25 11.9844)"/>
    </clipPath>
    </defs>
    </svg>
    </div>`,
    responsive: [
        {
            breakpoint: 767, // Adjust breakpoint as needed
            settings: {
              infinite: true,
            }
        }
    ]
});
  
   $('.custom_product_slider_nav_horizontal').slick({
   	slidesToShow: 5,
   	slidesToScroll: 1,
   	asNavFor: '.custom_product_slider_for_horizontal',
    dots: false,
    arrows: false,
   	focusOnSelect: true,
    infinite: false,
    responsive: [
        {
            breakpoint: 992, // Adjust breakpoint as needed
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              arrows: false,
            }
        },
        {
            breakpoint: 767, // Adjust breakpoint as needed
            settings: {
              infinite: true,
            }
        }
    ]
   });
    if ($('.custom_product_slider_nav_horizontal .slick-slide').length <= 5) {
      $('.custom_product_slider_nav_horizontal').addClass('apply-transform-fix');
    }
  /* end horizontal slider */

  $('.custom_product_slider_for').slick({
   	slidesToShow: 1,
   	slidesToScroll: 1,
   	arrows: false,
   	fade: false,
    asNavFor: '.custom_product_slider_nav',
    adaptiveHeight: true,
    infinite: false,
   });
  
   $('.custom_product_slider_nav').slick({
   	slidesToShow: 4,
   	slidesToScroll: 1,
   	asNavFor: '.custom_product_slider_for',
    dots: false,
    arrows: true,
   	focusOnSelect: true,
    vertical: true,
    verticalSwiping: false,
    infinite: false,
    prevArrow:`<div class='slick-arrow prev'><svg xmlns="http://www.w3.org/2000/svg" width="12.5" height="21.032" viewBox="0 0 12.5 21.032">
  <path id="arrow_forward_ios_FILL0_wght700_GRAD0_opsz48" d="M21.716,23.732,23.7,21.723l-8.507-8.507L23.7,4.709,21.716,2.7,11.2,13.216Z" transform="translate(-11.2 -2.7)" fill="#464646"/>
</svg></div>`,
    nextArrow:`<div class='slick-arrow next'><svg xmlns="http://www.w3.org/2000/svg" width="12.5" height="21.032" viewBox="0 0 12.5 21.032">
  <path id="arrow_forward_ios_FILL0_wght700_GRAD0_opsz48" d="M13.184,23.732,11.2,21.723l8.507-8.507L11.2,4.709,13.184,2.7,23.7,13.216Z" transform="translate(-11.2 -2.7)" fill="#464646"/>
</svg></div>`,
    responsive: [
        {
            breakpoint: 992, // Adjust breakpoint as needed
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              vertical: false,
              arrows: false,
            }
        }
    ]
   });
  var slideCount = $('.custom_product_slider_nav').slick('getSlick').slideCount;
  if (slideCount <= 4) {
    $('.product_media_slider').addClass('lessthenfour_or_equalto');
  }
  if ($('.slick-arrow').length != 0 || $('.slick-arrow').is(':visible')) {
    $('.product_media_slider').addClass('arrows');
  }
  $('.mobile_comparison_table .table_slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      //asNavFor: '.mobile_comparison_table .table_slider-nav',
      adaptiveHeight: true,
      draggable: false,
      swipe: false,
  });
  // $('.mobile_comparison_table  .table_slider-nav').slick({
  //   dots: false,
  //   infinite: true,
  //   arrows: true,
  //   asNavFor: '.mobile_comparison_table .table_slider',
  //   speed: 300,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   adaptiveHeight: true,
  //   focusOnSelect: true,
  // });
  var Mushroomheight = $('.mobile_comparison_table .comparison_table_first_column .item.mushroom').outerHeight()
  var Prebioticheight = $('.mobile_comparison_table .comparison_table_first_column .item.prebiotic').outerHeight()
  var Deliciousheight = $('.mobile_comparison_table .comparison_table_first_column .item.delicious').outerHeight()
  var Enhancedheight = $('.mobile_comparison_table .comparison_table_first_column .item.enhanced').outerHeight()
  $(".mobile_comparison_table .comparison_table_second_column .item.first_item, .mobile_comparison_table .table_slider .item.first_item").css("height", Mushroomheight);
  $(".mobile_comparison_table .comparison_table_second_column .item.second_item, .mobile_comparison_table .table_slider .item.second_item").css("height", Prebioticheight);
  $(".mobile_comparison_table .comparison_table_second_column .item.three_item, .mobile_comparison_table .table_slider .item.three_item").css("height", Deliciousheight);
  $(".mobile_comparison_table .comparison_table_second_column .item.four_item, .mobile_comparison_table .table_slider .item.four_item").css("height", Enhancedheight);

});

$(document).ready(function(){
    $('.article_content .table_of_content ul li a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        var getHeaderHeight = $('.section-header.shopify-section-group-header-group').height() + 15;
        
        // Remove active class from all links
        $('.article_content .table_of_content ul li a').removeClass('active');
        
        // Add active class to the clicked link
        $(this).addClass('active');
        
        var target = this.hash;
        var $target = $(target);
        
        $('html, body').stop().animate({
            'scrollTop': $target.offset().top - getHeaderHeight
        }, 900, 'swing', function () {
            // window.location.hash = target;
        });
    });
    $('.comparison_table_suppliment_modal .modal_content .close_icon, .comparison_table_suppliment_modal .overlay').on('click', function (e) {
      $('.product_comparison_table .inner_comparison_table .table_content .list .inner_wrap').removeClass('active');
      $('html').removeClass('pop_up_show');
    });
    $('.product_comparison_table .inner_comparison_table .table_content .list .inner_wrap button').on('click', function (e) {
      $(this).parent().addClass('active');
      $('html').addClass('pop_up_show');
    });
    // $('.comparison_table_suppliment_modal .modal_content .close_icon').on('click', function (e) {
    //   $('.product_comparison_table .inner_comparison_table .table_content .list .inner_wrap').removeClass('active');
    // });
    // $('.mobile_comparison_table .table_slider .item button').on('click', function (e) {
    //   $(this).parent().addClass('active');
    // });
  
    $('#pop_up_1 .close_icon, .comparison_table_suppliment_modal .overlay').on('click', function (e) {
      $('#pop_up_1.comparison_table_suppliment_modal').removeClass('active');
      $('html').removeClass('pop_up_show');
    });
    $('#orange_1').on('click', function (e) {
      $('#pop_up_1.comparison_table_suppliment_modal').addClass('active');
      $('html').addClass('pop_up_show');
    });

    $('#pop_up_2 .close_icon, .comparison_table_suppliment_modal .overlay').on('click', function (e) {
      $('#pop_up_2.comparison_table_suppliment_modal').removeClass('active');
      $('html').removeClass('pop_up_show');
    });
    $('#orange_2').on('click', function (e) {
      $('#pop_up_2.comparison_table_suppliment_modal').addClass('active');
      $('html').addClass('pop_up_show');
    });

    $('#pop_up_3 .close_icon, .comparison_table_suppliment_modal .overlay').on('click', function (e) {
      $('#pop_up_3.comparison_table_suppliment_modal').removeClass('active');
      $('html').removeClass('pop_up_show');
    });
    $('#orange_3').on('click', function (e) {
      $('#pop_up_3.comparison_table_suppliment_modal').addClass('active');
      $('html').addClass('pop_up_show');
    });

    $('#pop_up_4 .close_icon, .comparison_table_suppliment_modal .overlay').on('click', function (e) {
      $('#pop_up_4.comparison_table_suppliment_modal').removeClass('active');
      $('html').removeClass('pop_up_show');
    });
    $('#orange_4').on('click', function (e) {
      $('#pop_up_4.comparison_table_suppliment_modal').addClass('active');
      $('html').addClass('pop_up_show');
    });
    
}); 